const rankingItems = [
  { rank: 1, title: '剑与远方', tag: '奇幻冒险', heat: '🔥 2.3w', change: 'up' as const },
  { rank: 2, title: '修灵纪', tag: '国漫精选', heat: '🔥 1.9w', change: 'up' as const },
  { rank: 3, title: '心跳的频率', tag: '恋爱甜宠', heat: '🔥 1.8w', change: 'up' as const },
  { rank: 4, title: '星界战记', tag: '热血战斗', heat: '1.5w', change: 'down' as const },
  { rank: 5, title: '青春日常', tag: '校园日常', heat: '1.3w', change: 'same' as const },
  { rank: 6, title: '暗影追踪', tag: '悬疑推理', heat: '1.1w', change: 'up' as const },
  { rank: 7, title: '妖灵异谈', tag: '日漫推荐', heat: '9800', change: 'new' as const },
];

const changeIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-500',
  down: 'ri-arrow-down-line text-foreground-400',
  same: 'ri-subtract-line text-foreground-400',
  new: 'text-primary-500',
};

const changeLabel: Record<string, string> = {
  up: '',
  down: '',
  same: '',
  new: 'NEW',
};

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            热门排行
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            根据阅读热度实时更新的漫画排行榜，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-lg overflow-hidden">
          {rankingItems.map((item) => (
            <a
              key={item.title}
              href="#ranking"
              className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 border-b border-background-200/70 last:border-b-0 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-950 truncate whitespace-nowrap">{item.title}</span>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap flex-shrink-0">{item.tag}</span>
                </div>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-600 whitespace-nowrap">{item.heat}</span>
                {item.change === 'new' ? (
                  <span className={`text-xs font-bold flex-shrink-0 ${changeIcon[item.change]}`}>
                    {changeLabel[item.change]}
                  </span>
                ) : (
                  <span className={`flex items-center flex-shrink-0 ${changeIcon[item.change]}`}>
                    <i className={`${changeIcon[item.change]} text-sm`}></i>
                  </span>
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}